import { useQuery } from 'react-query'
import { FindByIdsResponse } from './types'
import { useCreateBetterIdRequest } from 'lib/services/config/betterId-config'

const useFindProductByIds = (ids: number[]) => {
  const { createBetterIdRequest } = useCreateBetterIdRequest()
  const queryString = `productsIds=${ids.map(encodeURIComponent).join(',')}`
  const url = `operations/assets/find-by-products-Ids?${queryString}`

  return useQuery<FindByIdsResponse>(
    ['productsByIds', ids],
    () => createBetterIdRequest(url, {}, 'GET'),
    {
      keepPreviousData: true,
      enabled: ids.length > 0,
    }
  )
}

export default useFindProductByIds
